import ContractAttachment from '@/components/ContractAttachment'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { formatDateWithFormatter, randomAvatarSrc } from '@/utils/function'
import React from 'react'
import { Avatar, Typogaphy } from 'vnetwork-ui'
import { getContractProcessHistories } from '../../../services'
import { ProcessHistory } from '../../../types'

import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import useAuthStore from '@/stores/useAuthStore'

interface IProcessHitoriesProps {
    shouldCheckRegistrationDate?: boolean
    contractID: number
    contractProcessID: number
}

const HistoryComponent: React.FC<IProcessHitoriesProps> = ({
    contractID,
    contractProcessID,
    shouldCheckRegistrationDate = false,
}) => {
    const { employee } = useAuthStore()
    const { data: histories, renderState } = useQueryWithHandler({
        queryFn: () =>
            getContractProcessHistories({ contractID, contractProcessID }),
        queryKey: [
            QUERY_KEYS.PROCESSES_HISTORIES,
            contractID,
            contractProcessID,
        ],
    })

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    // const feedbackStatuses = PROCESS_FEEDBACK_STATUS(t)

    return (
        <div>
            {/* Chat-like thread: self = right, others = left */}
            <div className="space-y-3">
                {histories?.map((history: ProcessHistory, index: number) => {
                    const isSelf =
                        !!employee?.employee_id &&
                        history?.employee_id === employee.employee_id

                    // const fbStatus = feedbackStatuses?.find(
                    //     (s) => s.value === history?.process_feedback_status
                    // )

                    return (
                        <div
                            key={history.process_history_id || index}
                            className={
                                isSelf
                                    ? 'flex justify-end'
                                    : 'flex justify-start'
                            }
                        >
                            <div
                                className={`max-w-[85%] ${isSelf ? 'ml-auto' : ''}`}
                            >
                                {/* Name outside bubble */}
                                <div
                                    className={`mb-1 ${isSelf ? 'text-right pr-10' : 'pl-10'}`}
                                >
                                    <Typogaphy className="text-xs font-medium text-gray-600">
                                        {history?.employee_name || '---'}
                                    </Typogaphy>
                                </div>

                                {/* Avatar + Bubble row */}
                                <div
                                    className={`flex items-start gap-2 ${isSelf ? 'flex-row-reverse' : ''}`}
                                >
                                    <Avatar
                                        size="small"
                                        src={randomAvatarSrc(
                                            history?.employee_name
                                        )}
                                        className="shrink-0"
                                    />
                                    <div
                                        className={
                                            isSelf
                                                ? 'rounded-2xl rounded-tr-none bg-blue-100/80 px-3 py-2.5 min-w-0'
                                                : 'rounded-2xl rounded-tl-none bg-gray-100 px-3 py-2.5 min-w-0'
                                        }
                                    >
                                        <Typogaphy className="text-sm text-gray-800 whitespace-pre-wrap">
                                            {history?.process_feedback || '---'}
                                        </Typogaphy>

                                        {history.attachments?.length > 0 && (
                                            <div className="mt-2">
                                                <ContractAttachment
                                                    attachments={
                                                        history?.attachments ||
                                                        []
                                                    }
                                                    shouldCheckRegistrationDate={
                                                        shouldCheckRegistrationDate
                                                    }
                                                    contractID={contractID}
                                                    hideLabel
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Timestamp outside bubble */}
                                <Typogaphy
                                    className={`text-[11px] text-gray-400 mt-1 ${isSelf ? 'text-right pr-10' : 'pl-10'}`}
                                >
                                    {formatDateWithFormatter(
                                        history?.created_at,
                                        'HH:mm',
                                        { fromUTC: true }
                                    )}
                                </Typogaphy>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default HistoryComponent
